<main class="agpr-viMonitorSetup" [agprLoading]="isLoading">
    <header class="agpr-viMonitorSetup-header">
        @if (isNew) {
            <h2 class="agpr-viMonitorSetup-heading">{{ 'VisibilityIntelligence.monitorSetup.heading' | localize }}</h2>
            <div class="agpr-viMonitorSetup-subHeading">{{ 'VisibilityIntelligence.monitorSetup.subHeading' | localize }}</div>
            <p class="agpr-viMonitorSetup-description">{{ 'VisibilityIntelligence.monitorSetup.description' | localize }}</p>
        } @else {
            <div class="agpr-viMonitorSetup-nameTitle">{{ monitor?.name }}</div>
            <h2 class="agpr-viMonitorSetup-heading">{{ 'VisibilityIntelligence.monitorSetup.edit.heading' | localize }}</h2>
            <agpr-message
                [severity]="messageSeverity.info"
                [bottomMargin]="false"
            >
                <p>{{ 'VisibilityIntelligence.monitorSetup.edit.infoMessage' | localize }}</p>
            </agpr-message>
        }
    </header>

    <section class="agpr-viMonitorSetup-main">
        <agpr-scroll-panel #mainScrollPanel>
            <div class="agpr-viMonitorSetup-main-content">
                <div class="agpr-viMonitorSetup-sectionCard">
                    <div class="agpr-viMonitorSetup-sectionCard-field">
                        <agpr-text-input
                            [id]="id + '_name'"
                            label="VisibilityIntelligence.monitorSetup.name.label"
                            placeholder="VisibilityIntelligence.monitorSetup.name.placeholder"
                            [ngModel]="monitorName"
                            (ngModelChange)="onNameChanged($event)"
                            [bottomMargin]="false"
                            [required]="true"
                            [maxLength]="64"
                        ></agpr-text-input>
                        @if (displayErrors && hasNameRequiredError) {
                            <agpr-form-message [marginBottom]="0">
                                {{ 'VisibilityIntelligence.monitorSetup.name.requiredError' | localize }}
                            </agpr-form-message>
                        }
                    </div>
                </div>
                <ng-container *ngTemplateOutlet="sectionCard; context: { $implicit: settingsCard, filledTemplate: settingsFilled }"></ng-container>
                <ng-container *ngTemplateOutlet="sectionCard; context: { $implicit: brandCard, filledTemplate: brandFilled }"></ng-container>
                <ng-container *ngTemplateOutlet="sectionCard; context: { $implicit: questionsCard, filledTemplate: questionsFilled }"></ng-container>
            </div>
        </agpr-scroll-panel>
    </section>

    <section class="agpr-viMonitorSetup-footer">
        <agpr-action-bar>
            <ng-template #left>
                <agpr-button
                    [id]="id + '_cancel'"
                    [style]="buttonTypes.secondary"
                    label="cancel"
                    (click)="cancel()"
                ></agpr-button>
            </ng-template>

            <ng-template #right>
                @if (isNew) {
                    <agpr-button
                        [id]="id + '_saveAsDraft'"
                        [style]="buttonTypes.primaryB"
                        label="saveAsDraft"
                        (click)="createMonitor()"
                    ></agpr-button>
                } @else {
                    @if (monitor?.status === monitorStatus.draft) {
                        <agpr-button
                            [id]="id + '_saveChanges'"
                            [style]="buttonTypes.primaryB"
                            label="saveChanges"
                            [disabled]="!hasUnsavedChanges"
                            [tooltip]="!hasUnsavedChanges ? 'VisibilityIntelligence.monitorSetup.editMonitor.disabledTooltip.noChanges' : ''"
                            (click)="saveChanges()"
                        ></agpr-button>
                    } @else if (monitor?.status === monitorStatus.paused) {
                        <agpr-button
                            [id]="id + '_savePausedChanges'"
                            [style]="buttonTypes.primary"
                            label="saveChanges"
                            (click)="updateMonitor()"
                            [disabled]="editDisabled"
                            [tooltip]="editDisabledTooltip"
                        ></agpr-button>
                    }
                }
                <agpr-button
                    [id]="id + '_activate'"
                    [style]="buttonTypes.primary"
                    label="activate"
                    (click)="activate()"
                    [disabled]="activateDisabled"
                    [tooltip]="activateDisabledTooltip"
                    tooltipPosition="top"
                ></agpr-button>
            </ng-template>
        </agpr-action-bar>
    </section>
</main>

<ng-template #sectionCard let-card let-filledTemplate="filledTemplate">
    <div class="agpr-viMonitorSetup-sectionCard">
        <div class="agpr-viMonitorSetup-header">
            <h3 class="agpr-viMonitorSetup-heading">{{ card.header | localize }}</h3>
            <p class="agpr-viMonitorSetup-subHeading">{{ card.subHeader | localize }}</p>
            <p class="agpr-viMonitorSetup-description">{{ card.message | localize }}</p>
        </div>

        @if (card.infoMessage) {
            <agpr-message [severity]="messageSeverity.info" [bottomMargin]="false">
                <p>{{ card.infoMessage | localize }}</p>
            </agpr-message>
        }

        <div class="agpr-viMonitorSetup-sectionCard-content">
            @if (card.isFilled) {
                <ng-container *ngTemplateOutlet="filledTemplate"></ng-container>
            } @else {
                <div class="agpr-viMonitorSetup-sectionCard-noContent">
                    <span role="img" class="agpr-viMonitorSetup-sectionCard-noContent-icon fa-regular fa-circle"></span>
                    <span>{{ card.emptyMessage | localize }}</span>
                </div>
            }
        </div>
        <div class="agpr-viMonitorSetup-sectionCard-actions">
            @if (monitor?.questions?.length && card.warningIconTooltip) {
                <span
                    role="img"
                    class="fa-solid fa-circle-exclamation agpr-viMonitorSetup-sectionCard-warningIcon"
                    [agprTooltip]="card.warningIconTooltip"
                    tooltipPosition="left"
                ></span>
            }
            @let buttonLabel = card.isFilled ? (card.editActionLabel ?? card.actionLabel) : card.actionLabel;
            <agpr-button
                [id]="id + '_sectionCard_' + buttonLabel"
                class="agpr-viMonitorSetup-sectionCard-button"
                [style]="buttonTypes.tertiary"
                [label]="buttonLabel"
                (click)="card.onAction()"
                [disabled]="!!card.actionDisabled"
            ></agpr-button>
        </div>
        @if (card.showSummary) {
            <agpr-vi-active-question-summary
                [id]="id + '_activeQuestionSummary'"
                class="agpr-viMonitorSetup-sectionCard-activeQuestionSummary"
                [questionsCount]="monitor?.questions?.length ?? 0"
            ></agpr-vi-active-question-summary>
        }
    </div>
</ng-template>

<ng-template #settingsFilled>
    <div class="agpr-viMonitorSetup-summary">
        <!-- Answer Engines -->
        <div class="agpr-viMonitorSetup-summaryRow agpr-viMonitorSetup-summaryRow--iconValue">
            <span role="img" class="agpr-viMonitorSetup-summary-icon fa-solid fa-circle-check"></span>
            <div class="agpr-viMonitorSetup-summary-label">
                {{ 'VisibilityIntelligence.monitorSetup.settings.summary.answerEngines' | localize }}
            </div>
            <div class="agpr-viMonitorSetup-summary-value agpr-viMonitorSetup-summary-engineList">
                @for (engine of selectedAnswerEngines; track engine.type) {
                    <span
                        class="agpr-viMonitorSetup-summary-engine"
                        [agprTooltip]="engine.label"
                        tooltipPosition="top"
                    >
                        <img
                            class="agpr-viMonitorSetup-summary-engineLogo"
                            [src]="appBaseHref + engine.logoUrl"
                            [alt]="engine.label | localize"
                        />
                    </span>
                }
            </div>
        </div>
        <!-- Analysis Focus -->
        <div class="agpr-viMonitorSetup-summaryRow">
            <span role="img" class="agpr-viMonitorSetup-summary-icon fa-solid fa-circle-check"></span>
            <div class="agpr-viMonitorSetup-summary-label">
                {{ 'VisibilityIntelligence.monitorSetup.settings.summary.analysisFocus' | localize }}
            </div>
            <div class="agpr-viMonitorSetup-summary-value">
                @for (focus of monitor?.analysisFocus; track focus; let isLast = $last) {
                    <span>{{ isLast ? focus : focus + ', ' }}</span>
                }
            </div>
        </div>
        <!-- Language -->
        <div class="agpr-viMonitorSetup-summaryRow">
            <span role="img" class="agpr-viMonitorSetup-summary-icon fa-solid fa-circle-check"></span>
            <div class="agpr-viMonitorSetup-summary-label">
                {{ 'VisibilityIntelligence.monitorSetup.settings.summary.language' | localize }}
            </div>
            <div class="agpr-viMonitorSetup-summary-value">
                {{ languageLabel }}
            </div>
        </div>
        <!-- Competitor Benchmarking -->
        <div class="agpr-viMonitorSetup-summaryRow">
            <span role="img" class="agpr-viMonitorSetup-summary-icon fa-solid fa-circle-check"></span>
            <div class="agpr-viMonitorSetup-summary-label">
                {{ 'VisibilityIntelligence.monitorSetup.settings.summary.competitorBenchmarking' | localize }}
            </div>
            <div class="agpr-viMonitorSetup-summary-value">
                {{ (monitor?.isCompetitiveBenchmarking
                    ? 'VisibilityIntelligence.monitorSetup.settings.summary.enabled'
                    : 'VisibilityIntelligence.monitorSetup.settings.summary.disabled') | localize }}
            </div>
        </div>
    </div>
</ng-template>

<ng-template #brandFilled>
    <div class="agpr-viMonitorSetup-summary">
        @if (monitor?.brand?.name) {
             <!-- Brand -->
            <div class="agpr-viMonitorSetup-summaryRow">
                @if (monitor?.brand?.nameVariations?.length) {
                    <span role="img" class="agpr-viMonitorSetup-summary-icon fa-solid fa-circle-check"></span>
                } @else {
                    <span
                        role="img"
                        class="fa-solid fa-circle-exclamation agpr-viMonitorSetup-summary-icon agpr-viMonitorSetup-summary-icon--warning"
                        [agprTooltip]="'VisibilityIntelligence.monitorSetup.settings.summary.brand.warningTooltip'"
                    ></span>
                }
                <div class="agpr-viMonitorSetup-summary-label">
                    {{ 'VisibilityIntelligence.monitorSetup.settings.summary.brand' | localize }}
                </div>
                <div class="agpr-viMonitorSetup-summary-value">
                    {{ monitor?.brand?.name }}
                </div>
            </div>
         }
        @if (monitor?.competitors?.length) {
            <!-- Competitors -->
            <div class="agpr-viMonitorSetup-summaryRow">
                @if (!hasCompetitorsWarning) {
                    <span role="img" class="agpr-viMonitorSetup-summary-icon fa-solid fa-circle-check"></span>
                } @else {
                    <span
                        role="img"
                        class="fa-solid fa-circle-exclamation agpr-viMonitorSetup-summary-icon agpr-viMonitorSetup-summary-icon--warning"
                        [agprTooltip]="'VisibilityIntelligence.monitorSetup.settings.summary.brand.warningTooltip'"
                    ></span>
                }
                <div class="agpr-viMonitorSetup-summary-label">
                    {{ 'VisibilityIntelligence.monitorSetup.settings.summary.competitors' | localize }}
                </div>
                <div class="agpr-viMonitorSetup-summary-value">
                    @for (competitor of monitor?.competitors; track competitor.name; let isLast = $last) {
                        <span>{{ isLast ? competitor.name : competitor.name + ', ' }}</span>
                    }
                </div>
            </div>
        }
    </div>
</ng-template>

<ng-template #questionsFilled>
    <div class="agpr-viMonitorSetup-summary">
        <!-- Question Total Count -->
        <div class="agpr-viMonitorSetup-summaryRow">
            @if (questionsCard.isStale) {
                <span role="img" class="fa-solid fa-circle-exclamation agpr-viMonitorSetup-summary-icon agpr-viMonitorSetup-summary-icon--warning"></span>
            } @else {
                <span role="img" class="agpr-viMonitorSetup-summary-icon fa-solid fa-circle-check"></span>
            }
            <div class="agpr-viMonitorSetup-summary-value">
                {{ 'VisibilityIntelligence.monitorSetup.questions.summary.count' | localize: { count: monitor?.questions?.length ?? 0 } }}
            </div>
        </div>
    </div>
    <div class="agpr-viMonitorSetup-questionsSummary">
        @if (questionsCard.isStale) {
            <agpr-message [severity]="messageSeverity.warning">
                <p>{{ 'VisibilityIntelligence.monitorSetup.questions.staleWarning' | localize }}</p>
            </agpr-message>
        }
        <div class="agpr-viMonitorSetup-questionsSummary-label">
            {{ 'VisibilityIntelligence.monitorSetup.questions.summary.focus' | localize }}
        </div>
        <div class="agpr-viMonitorSetup-questionsSummary-dimensions">
            @for (dimension of questionDimensionSummary; track dimension.label) {
                <div class="agpr-viMonitorSetup-questionsSummary-dimension">
                    <span class="agpr-viMonitorSetup-questionsSummary-dimension-label">{{ dimension.label | localize }}</span>
                    <span class="agpr-viMonitorSetup-questionsSummary-dimension-count">{{ dimension.count }}</span>
                </div>
            }
        </div>
    </div>
</ng-template>

<ng-template #activateConfirmContent>
    <div class="agpr-viMonitorSetup-activateConfirm">
        <span
            role="img"
            class="agpr-viMonitorSetup-activateConfirm-icon fa-kit-duotone fa-agpr-vi-monitor"
            aria-hidden="true"
        ></span>
        <div class="agpr-viMonitorSetup-activateConfirm-heading">
            {{ 'VisibilityIntelligence.monitorSetup.activateConfirm.heading' | localize }}
        </div>
        <div class="agpr-viMonitorSetup-activateConfirm-subHeading">
            {{ 'VisibilityIntelligence.monitorSetup.activateConfirm.subHeading' | localize }}
        </div>
        <p
            class="agpr-viMonitorSetup-activateConfirm-message"
            [innerHTML]="'VisibilityIntelligence.monitorSetup.activateConfirm.message' | localize: {
                used: monitor?.questions?.length ?? 0,
                remaining: remainingActiveQuestionQuota
        }"></p>
        <agpr-message [severity]="messageSeverity.info" [bottomMargin]="false">
            <div [innerHTML]="'VisibilityIntelligence.monitorSetup.activateConfirm.banner' | localize: {contactLink: 'https://www.agilitypr.com/contact/'}"></div>
        </agpr-message>
    </div>
</ng-template>
